module.exports = __webpack_public_path__ + "static/media/Xiaomi Mi Mix Alpha Back.18a2ab83.png";